import React, { useEffect, useState } from 'react';
import Container from 'react-bootstrap/esm/Container';
import { BookingAddOnCardGroup } from './BookingAddOnCardGroup';
import './BookingAddOnDeals.css';
import {
  getToken,
  sessionStorageGetItem,
  sessionStorageSetItem,
  tokenIsValid,
} from './Function';
import moment from 'moment';
import axios from 'axios';

export const BookingAddOnDeals = ({ component }) => {
  component = component == null ? '5' : component;
  const CWL_HOLIDAYS_URL = process.env.REACT_APP_CAUSEWAYLINK_HOLIDAYS_URL;
  const API_KEY = process.env.REACT_APP_CAUSEWAYLINK_HOLIDAYS_KEY;
  const [data, setHolidaysData] = useState(null);
  const [addOns, setAddOns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const destinationData = JSON.parse(sessionStorageGetItem('Destination_data'));

  useEffect(() => {
    const getHolidaysData = async () => {
      try {
        const holidays_response = await fetch(
          `${CWL_HOLIDAYS_URL}/packages/express/addon/v2/${destinationData.subplaceuniqueshortname}`,
          {
            method: 'GET',
            mode: 'cors',
            headers: {
              apikey: API_KEY,
              Authorization: getToken(),
            },
          }
        );
        if (!holidays_response.ok) {
          throw new Error(
            `This is an HTTP error: The status is ${holidays_response.status}`
          );
        }
        let Holidays_Data = await holidays_response.json();
        setHolidaysData(Holidays_Data);
        sessionStorageSetItem(
          'addon_data',
          JSON.stringify(Holidays_Data.results)
        );
        setError(null);

        // console.log(Holidays_Data)
      } catch (err) {
        setError(err.message);
        setHolidaysData(null);
        // console.log("Error")
        // console.log(err.message)
      } finally {
        setLoading(false);
      }
    };

    const getAddOns = async () => {
      try {
        const origin = JSON.parse(
          sessionStorageGetItem('Origin_data')
        )?.subplaceuniqueshortname;

        const destination = JSON.parse(
          sessionStorageGetItem('Destination_data')
        )?.subplaceuniqueshortname;

        const departDate = moment(
          JSON.parse(sessionStorageGetItem('departData'))?.departure_time
        ).format('YYYY-MM-DD');

        const returnDate = moment(
          JSON.parse(sessionStorageGetItem('returnData'))?.departure_time
        ).format('YYYY-MM-DD');

        const response = await axios.post(
          `${process.env.REACT_APP_SERVER_URL}/order/addon/from/${origin}/to/${destination}`,
          {
            DepartDate: departDate,
            ReturnDate: returnDate,
          },
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: getToken(),
            },
          }
        );

        setAddOns([...response.data.depart, ...response.data.return]);
        sessionStorageSetItem(
          'other_addon',
          JSON.stringify([...response.data.depart, ...response.data.return])
        );
      } catch (error) {
        setError(error.message);
        setAddOns([]);
        sessionStorageSetItem('other_addon', JSON.stringify([]));
        sessionStorage.removeItem('insuranceAddOn');
        sessionStorage.removeItem('healthCareAddOn');
      } finally {
        setLoading(false);
      }
    };

    tokenIsValid();
    getAddOns();
    getHolidaysData();
  }, []);
  return (
    <>
      {data?.results.length > 0 || addOns.length > 0 ? (
        <div className='blur'>
          <Container>
            <div className='bookingAddOnTitleContainer'>
              <h1>ADD ON Deals</h1>
              <h5>
                Add on & save more! Unlock up to 30% off activities in KL now!
              </h5>
            </div>
          </Container>
          <div className='maxWidth m-auto'>
            <BookingAddOnCardGroup component={component} data={data} />
          </div>
        </div>
      ) : (
        ''
      )}
    </>
  );
};
